import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MatchResult } from '@/types';

interface FormGuideProps {
  results: MatchResult[];
}

const resultColors: Record<string, string> = {
  W: 'bg-green-500 text-white hover:bg-green-600',
  D: 'bg-yellow-500 text-white hover:bg-yellow-600',
  L: 'bg-red-500 text-white hover:bg-red-600',
};

const FormGuide: React.FC<FormGuideProps> = ({ results }) => {
  const navigate = useNavigate();

  if (!results || results.length === 0) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-1">Form:</span>
      {results.map((match) => (
        <button
          key={match.matchId}
          onClick={() => navigate(`/matches/wyscout/${match.matchId}`)}
          className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold cursor-pointer transition-colors ${resultColors[match.result] || 'bg-gray-400 text-white hover:bg-gray-500'}`}
          title={`${match.label} (${match.dateUtc?.split(' ')[0] || ''})`}
        >
          {match.result}
        </button>
      ))}
    </div>
  );
};

export default FormGuide;
